import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useParams } from "react-router-dom";
import { getJadaiReceiptById } from "./services/jadaireceipt.services";
import { clearJadaiReceiptDetail } from "./jadaiReceiptSlice";
import { getAllUnit } from "../unit/services/unit.services";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { PRINT_ACCESS } from "../../_contstants/common";
import { IoMdPrint } from "react-icons/io";
import moment from "moment";
import { LoadingPanel } from "../../components/layout/Loading";
// import { MdOutlineFileDownload } from "react-icons/md";
// import { API_URL } from "../../app/config";
// import { ErrorToast } from "../../components/toast/Toasts";
import { Checkbox } from "@progress/kendo-react-inputs";

const JadaiReceiptVoucherPDF = () => {
  const dispatch = useAppDispatch();
  const param = useParams();
  const jadai_receipt_guid = param?.jadai_receipt_guid || "";
  const JadaiReceiptDetail = useAppSelector(
    (state) => state.jadaireceipt.JadaiReceiptDetail,
  );
  const UnitList = useAppSelector((state) => state.unit.UnitList);

  const karigarIdWiseOutStandingAmount =
    JadaiReceiptDetail?.jadai_receipt_order?.length > 0 &&
    JadaiReceiptDetail?.jadai_receipt_order[0]?.karigarIdWiseOutStandingAmount
      ?.length > 0
      ? JadaiReceiptDetail?.jadai_receipt_order[0]
          ?.karigarIdWiseOutStandingAmount[0]
      : {};
  const loading = useAppSelector((state) => state.jadaireceipt.loading);
  const isPrintAccess = checkAcessRights("/jadaireceipt", PRINT_ACCESS);
  const gridRef = useRef<any>(null);
  const [withImage, setWithImage] = React.useState(false);

  const handleWithImage = () => {
    setWithImage((pre) => !pre);
  };

  useEffect(() => {
    return () => {
      dispatch(clearJadaiReceiptDetail());
    };
  }, []);

  useEffect(() => {
    if (jadai_receipt_guid) {
      dispatch(getJadaiReceiptById(jadai_receipt_guid));
    }
  }, [jadai_receipt_guid]);
  useEffect(() => {
    if (!UnitList || UnitList?.length === 0) {
      dispatch(getAllUnit());
    }
  }, [UnitList, dispatch]);

  useEffect(() => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .no-print {
          display: none !important;
        }
        .receipt-order-item-print-break {
          page-break-inside: avoid;
        }
        .container {
          width: 100% !important;
          max-width: 100% !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        body {
          zoom: 70% !important;
        }
        .table-bordered, .table-bordered td, .table-bordered th {
          border: 1px solid #c2c2c2ff !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handlePrint = () => {
    window.print();
  };

/*
  const handleDownloadPdf = async (
    jadai_receipt_guid: string,
    receipt_no: any,
  ) => {
    try {
      const response = await fetch(
        `${API_URL}/Jadai/FIndByIDJadaiDownloadPDf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            jadai_receipt_guid,
            isimageview: withImage,
          }),
        },
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Jadai-receipt-${receipt_no || moment().date()}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download PDF! - Please try again later");
    }
  };
*/

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}

      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <div
            className="printbuttons no-print"
            style={{
              textAlign: "center",
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isPrintAccess && (
              <>
                <div
                  style={{
                    marginRight: "10px",
                    padding: "3px 10px",
                    border: "none",
                  }}
                >
                  <Checkbox
                    label="With Image "
                    size="large"
                    labelPlacement="before"
                    onChange={handleWithImage}
                    checked={withImage}
                  />
                </div>
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handlePrint}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              </>
            )}
            {/* {isPrintAccess && (
              <Button
                type="button"
                style={{
                  marginRight: "10px",
                  padding: "5px 10px",
                  border: "none",
                }}
                fillMode={"solid"}
                themeColor={"tertiary"}
                onClick={() =>
                  handleDownloadPdf(
                    jadai_receipt_guid,
                    JadaiReceiptDetail.receipt_no,
                  )
                }
              >
                <MdOutlineFileDownload style={{ fontSize: "20px" }} /> Download
              </Button>
            )} */}
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <Typography.h5
            style={{
              marginBottom: 0,
              textAlign: "center",
            }}
          >
            JADAI RECEIPT VOUCHER
          </Typography.h5>
          <Typography.h6
            style={{
              marginBottom: 15,
              textAlign: "center",
            }}
          >
            RECEIPT NO : {JadaiReceiptDetail?.receipt_no} | RECEIPT DATE :{" "}
            {moment(JadaiReceiptDetail?.receipt_date).format("DD/MM/YYYY")}
          </Typography.h6>
        </GridLayoutItem>
      </GridLayout>

      <div className="container">
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            flexDirection: "column",
            marginBottom: 10,
          }}
        >
          <div className="card-header bg-light">
            <h5 className="mb-0 fw-bold">Karigar Stock</h5>
          </div>
          <div className="stock-container">
            <div className="stock-item w-100">
              <div className="stock-header">
                <div
                  className={`indicator-dot amount-dot-${karigarIdWiseOutStandingAmount.Amount_credit_debit}`}
                ></div>
                <Typography.h6 className="stock-label">
                  Amount Balance
                </Typography.h6>
              </div>
              <Typography.h6
                className={`stock-value text-nowrap amount-value-${karigarIdWiseOutStandingAmount.Amount_credit_debit}`}
              >
                ₹
                {formatToIndianCurrencyWithoutSymbol(
                  karigarIdWiseOutStandingAmount.amount || 0,
                )}{" "}
                <span
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    fontSize: 16,
                  }}
                >
                  {karigarIdWiseOutStandingAmount.Amount_credit_debit}
                </span>
              </Typography.h6>
            </div>

            <div className="stock-item  w-100">
              <div className="stock-header">
                <div
                  className={`indicator-dot phine-dot-${karigarIdWiseOutStandingAmount.phine_credit_debit}`}
                ></div>
                <Typography.h6 className="stock-label">
                  Phine (gm) Stock
                </Typography.h6>
              </div>
              <Typography.h6
                className={`stock-value phine-value-${karigarIdWiseOutStandingAmount.phine_credit_debit}`}
              >
                {formatWeight(karigarIdWiseOutStandingAmount.phine)}{" "}
                <span
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    fontSize: 16,
                  }}
                >
                  {karigarIdWiseOutStandingAmount.phine_credit_debit}
                </span>
              </Typography.h6>
            </div>
          </div>
        </div>
        {/* Summary Information */}
        <div className="card summary-card mb-3">
          <div className="card-header bg-light">
            <h5 className="mb-0 fw-bold">Order Summary</h5>
          </div>
          <div className=" p-0">
            <table className="table table-bordered mb-0">
              <tbody>
                <tr>
                  <td style={{ width: "20%" }}>
                    <strong>Karigar</strong>
                    <br />
                    <span>{JadaiReceiptDetail?.karigar_name}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {JadaiReceiptDetail?.jadai_receipt_order?.map((item, index) => {
          return (
            <div
              key={item?.id || index}
              className={`card items-card receipt-order-item-print-break ${
                index ? "mt-4" : ""
              }`}
            >
              <div className="card-body p-0">
                <div className="p-1">
                  <h4 className="mb-0 fw-bold">Order Details</h4>
                  <div className="card items-card">
                    <div className="card-header bg-light p-1">
                      <h5 className="mb-0 fw-bold">
                        Order No: {item?.order_no}
                      </h5>
                    </div>
                    <div className="card-body p-0">
                      <table className="table table-bordered mb-0">
                        <tbody>
                          <tr>
                            <td style={{ width: "33.33%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Issue Date</strong>
                              </p>
                              <p className="m-0">
                                {moment(item?.issue_date).format("DD/MM/YYYY")}
                              </p>
                            </td>
                            <td style={{ width: "33.33%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Category</strong>
                              </p>
                              <p className="m-0">{item?.category_name}</p>
                            </td>
                            <td style={{ width: "33.33%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Sub Category</strong>
                              </p>
                              <p className="m-0">{item?.subcategory_name}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {item?.item_used_by_kariagr?.length > 0 && (
                    <div className="card items-card mt-1">
                      <div className="card-header bg-light p-1">
                        <h6 className="mb-0 fw-bold">Items Used By Karigar</h6>
                      </div>
                      <div className="card-body p-0">
                        <div className="approval-table">
                          <table className="table table-bordered mb-0 approval-items-table">
                            <thead>
                              <tr>
                                <th style={{ width: "10%" }}>Item Name</th>
                                <th style={{ width: "10%" }}>Weight (gm)</th>
                                <th style={{ width: "7%" }}>Pcs</th>
                                <th style={{ width: "8%" }}>Unit</th>
                                <th style={{ width: "10%" }}>Rate</th>
                                <th style={{ width: "10%" }}>Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item?.item_used_by_kariagr?.map(
                                (used_by_karigar: any, idx: number) => {
                                  return (
                                    <tr key={used_by_karigar?.id || idx}>
                                      <td>{used_by_karigar?.item_name}</td>
                                      <td>
                                        {formatWeight(used_by_karigar?.weight)}
                                      </td>
                                      <td>{used_by_karigar?.qty}</td>
                                      <td>
                                        {UnitList?.find(
                                          (u: any) =>
                                            u.id === used_by_karigar?.unit_id,
                                        )?.unit_name ||
                                          used_by_karigar?.unit_id}
                                      </td>
                                      <td>{used_by_karigar?.rate}</td>
                                      <td>{used_by_karigar?.total}</td>
                                    </tr>
                                  );
                                },
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                  <br />
                  <div className="card items-card">
                    <div className="card-body p-0">
                      <table className="table table-bordered mb-0">
                        <tbody>
                          <tr>
                            <td style={{ width: "16.66%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Gross Weight (gm)</strong>
                              </p>
                              <p className="m-0"> {item?.gross_weight}</p>
                            </td>
                            <td style={{ width: "16.66%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Stone Weight (gm)</strong>
                              </p>
                              <p className="m-0">{item?.stone_weight}</p>
                            </td>
                            <td style={{ width: "16.66%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Net Weight (gm)</strong>
                              </p>
                              <p className="m-0">{item?.net_weight}</p>
                            </td>
                            <td style={{ width: "16.66%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Stone Qty.</strong>
                              </p>
                              <p className="m-0"> {item?.stone_qty}</p>
                            </td>
                            <td style={{ width: "16.66%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Rate</strong>
                              </p>
                              <p className="m-0">{item?.rate}</p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "16.66%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Extra Cost</strong>
                              </p>
                              <p className="m-0"> {item?.extra_cost}</p>
                            </td>
                            <td style={{ width: "16.66%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Purity </strong>
                              </p>
                              <p className="m-0">
                                {item?.Carat || 0.0} {item?.purity}
                              </p>
                            </td>
                            <td style={{ width: "16.66%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Total </strong>
                              </p>
                              <p className="m-0">{item?.total}</p>
                            </td>
                            <td style={{ width: "16.66%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Kundan </strong>
                              </p>
                              <p className="m-0">{item?.kundan}</p>
                            </td>
                            <td style={{ width: "16.66%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Wax Weight </strong>
                              </p>
                              <p className="m-0">{item?.less_jadai_verification}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* <div className="table-responsive"> */}
                {/* <table className="table table-bordered mb-0 receipt-order-items-table">
                <tbody>
                  <tr>
                    <td>
                      <div className="card items-card">
                        <div className="card-header bg-light p-1">
                          <h6 className="mb-0">Item Details</h6>
                        </div>
                        <div className="card-body p-0">
                          <table className="table table-bordered mb-0">
                            <tbody>
                              <tr>
                                <td style={{ width: "25%" }}>
                                  <strong>Product</strong>
                                  <br />
                                  <span> Gold Chain 22 CT</span>
                                </td>
                                <td style={{ width: "25%" }}>
                                  <strong>Order No</strong>
                                  <br />
                                  <span>2</span>
                                </td>
                                <td style={{ width: "25%" }}>
                                  <strong>Size</strong>
                                  <br />
                                  <span>18</span>
                                </td>
                                <td style={{ width: "25%" }}>
                                  <strong>Weight</strong>
                                  <br />
                                  <span>26 gm</span>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Color</strong>
                                  <br />
                                  <span>Gold</span>
                                </td>
                                <td>
                                  <strong>Category</strong>
                                  <br />
                                  <span>Gold Chain</span>
                                </td>
                                <td>
                                  <strong>Purity</strong>
                                  <br />
                                  <span>22 CT</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="card items-card">
                        <div className="card-header bg-light p-1">
                          <h6 className="mb-0">Approval Items</h6>
                        </div>
                        <div className="card-body p-0">
                          <div className="approval-table">
                            <table className="table table-bordered mb-0 approval-items-table">
                              <thead>
                                <tr>
                                  <th>Type</th>
                                  <th>Item</th>
                                  <th>Weight</th>
                                  <th>Qty</th>
                                  <th>Remarks</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>SAMPLE</td>
                                  <td>Sample Chain</td>
                                  <td>60 gm</td>
                                  <td>2</td>
                                  <td>
                                    2 sample given asdfasd asdfasa asdfasd
                                    asdfasd
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table> */}
                {/* <table className="table table-bordered mb-0 receipt-order-items-table">
                <thead className="table-success">
                  <tr>
                    <th>Item Details</th>
                    <th>Specifications</th>
                    <th>Approval Items</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <h6
                        style={{
                          textTransform: "uppercase",
                          fontWeight: "bold",
                        }}
                      >
                        Gold Chain 22 CT
                      </h6>
                      <h6 className="text-muted">Order No : 2</h6>
                    </td>
                    <td>
                      <table className="table table-bordered specifications-table">
                        <tbody>
                          <tr>
                            <td>
                              <strong>Size</strong>
                            </td>
                            <td>18</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Weight</strong>
                            </td>
                            <td>26 gm</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Color</strong>
                            </td>
                            <td>Gold</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Category</strong>
                            </td>
                            <td>Gold Chain</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Purity</strong>
                            </td>
                            <td>22 CT</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <div className="approval-table">
                        <table className="table table-bordered mb-0 approval-items-table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>Item</th>
                              <th>Weight</th>
                              <th>Qty</th>
                              <th>Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>SAMPLE</td>
                              <td>Sample Chain</td>
                              <td>60 gm</td>
                              <td>2</td>
                              <td>2 sample given</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table> */}
                {/* </div> */}
              </div>
              <div
                className={`card p-2 shadow-sm border-0 mb-4 ${
                  !withImage && "no-print"
                }`}
              >
                <div className="d-flex flex-wrap gap-4">
                  {item?.chithi_image && (
                    <div className="position-relative rounded-3 overflow-hidden">
                      <h5
                        className="mb-2"
                        style={{
                          color: "#2c3e50",
                          fontWeight: "600",
                          fontSize: "1.1rem",
                        }}
                      >
                        Chithi Image
                      </h5>
                      <div
                        style={{
                          width: "150px",
                          height: "150px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          className="img-fluid object-fit-cover w-100 h-100"
                          style={{ cursor: "pointer" }}
                          src={item.chithi_image}
                          alt="Chithi Image"
                          onClick={() => window.open(item.chithi_image)}
                        />
                      </div>
                    </div>
                  )}
                  {item?.Images?.length > 0 && (
                    <div className="position-relative rounded-3 overflow-hidden">
                      <h5
                        className="mb-2"
                        style={{
                          color: "#2c3e50",
                          fontWeight: "600",
                          fontSize: "1.1rem",
                        }}
                      >
                        Receipt Images
                      </h5>
                      <div className="d-flex flex-wrap gap-2">
                        {item?.Images?.map((img: any) => (
                          <div
                            key={img.ID}
                            style={{
                              width: "150px",
                              height: "150px",
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              className="img-fluid object-fit-cover w-100 h-100"
                              style={{ cursor: "pointer" }}
                              src={img.ImageGallery}
                              alt="Receipt Image"
                              onClick={() => window.open(img.ImageGallery)}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default JadaiReceiptVoucherPDF;
